import styled from 'styled-components'

export const CheckBoxWrapper = styled.div`
    
`
export interface CheckBoxLabelProps {
    readOnly?: boolean;
}
export const CheckboxLabel = styled.label`
    position: relative;
    display: block;
    // width: 24px;
    // height: 24px;
    width: 16px;
    height: 16px;
    overflow: hidden;
    user-select: none;
    ${(props: CheckBoxLabelProps) => props.readOnly
        ? ''
        : `&: hover {
            cursor: pointer;
        }`
    }

    &::before {
        content: '';
        // height: 10px;
        // left: 1px;
        position: absolute;
        border-left: 2px solid #FFF;
        height: 6px;
        top: -6px;
        right: 15px;
        border-radius: 20px 20px 0 20px;
    }

    &::after {
        content: '';
        position: absolute;
        border-left: 2px solid #FFF;
        // height: 16px;
        // right: -4px;
        height: 10px;
        right: -7px;
        top: 0px;
        border-radius: 20px;
    }
`;

export interface CheckBoxInputProps {
    bgColor?: string;
    readOnly?: boolean;
}
export const CheckBoxInput = styled.input`
    display:none;
    &:checked + label {
        background: ${(props: CheckBoxInputProps) => props.bgColor ? props.bgColor : "#555"};
    }
`
export const CheckBox = styled.div`
    width: 16px;
    height: 16px;
    border-radius: 1px;
    border: solid 1px #555;
    & input:checked + label::before {
        // transform: rotate(-45deg) translatex(-3.5px) translatey(10px);
        transform: rotate(-45deg) translatex(-5px) translatey(12px);
        
    }
    & input:checked + label::after {
        // transform: rotate(45deg) translatex(-5px) translatey(11px);
        transform: rotate(45deg) translatex(-7px) translatey(10px);
        /* transition: all 0.3s; */
    }
    opacity: ${(props: CheckBoxInputProps) => (props.readOnly ? 0.3 : 1)};
`